var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    directives: [
      {
        name: "tooltip",
        rawName: "v-tooltip.right",
        value:
          _vm.statusMapping[_vm.status] &&
          _vm.statusMapping[_vm.status].tooltip,
        expression: "statusMapping[status] && statusMapping[status].tooltip",
        modifiers: { right: true }
      }
    ],
    class: _vm.statusMapping[_vm.status] && _vm.statusMapping[_vm.status].class
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }